import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { SaveButton, Checkbox, RequiredLabel, StatusHandler } from '../../../../components';
import Select from 'react-select'
import { fetchPrograms } from '../../../../features/organization/programs/slice';

const fields = [
  {
    key: 'location',
    label: 'Location/Media',
    name: 'location'
  },
  {
    key: 'testimonial',
    label: 'Testimoni',
    name: 'testimonial'
  },
  {
    key: 'gallery',
    label: 'Gallery',
    name: 'gallery'
  },
  {
    key: 'guest',
    label: 'Guest',
    name: 'guest'
  },
  {
    key: 'tag',
    label: 'Tag',
    name: 'tag'
  },
]

const defaultForm = {
  image: true,
  description: true,
  datetime: true,
  location: true,
  testimonial: true,
  gallery: true,
  guest: true,
  tag: true,
  program: {}
}

const FormExist = ({handleClose}) => {
  const dispatch = useDispatch()
  const [form, setForm] = React.useState(defaultForm)
  const { status, error, data_options } = useSelector(state => state.organizationPrograms)

  useEffect(() => {
    dispatch(fetchPrograms())
  // eslint-disable-next-line
  }, [])

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.checked
    })
  }

  const handleProgramSelect = (e) => {
    setForm({
      ...form,
      program: e
    })
  }

  const handleSubmit = () => {
    console.log({form})
  }

  return <>
    <div className="mb-8">
      <p className="text-sm text-gray-444 mb-5">
        <span className="mr-2">
          Choose existing program
        </span>
        <RequiredLabel />
      </p>
      <StatusHandler status={status} error={error} onRetry={() => dispatch(fetchPrograms())}>
        <Select
          options={data_options}
          className="w-full lg:w-2/3 text-sm"
          name="program_id"
          onChange={handleProgramSelect}
        />
      </StatusHandler>
    </div>

    <div className="mb-8" style={{columnCount: 2}}>
      { fields.map((field, index) => (
        <Checkbox
          className="mb-2"
          id={`${field.name}_${index}`}
          label={field.label}
          name={field.name}
          checked={form[field.name]}
          onChange={updateForm}
        />
      )) }
    </div>

    <div className="flex flex-wrap items-center">
      <div className="w-full md:w-auto lg:w-auto">
        <SaveButton type="button" mobileClassname="mb-5" onClick={handleSubmit}/>
      </div>
      <div className="w-full md:w-auto lg:w-auto text-center lg:text-left">
        <p className="cursor-pointer px-8 text-gray-444 underline text-xs lg:text-sm" onClick={handleClose}>Cancel</p>
      </div>
    </div>
  </>
}

export default FormExist
